import React, { useState, useEffect, createContext, useCallback } from 'react';
import useAuth from '../hooks/useAuth';
import { firestore } from './FirebaseContext';
import PropTypes from 'prop-types';

export const WalletContext = createContext({ saldo: 0, cobrar: () => {}, recargar: () => {}, transferir: () => {} });

WalletProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default function WalletProvider({ children }) {
  const { user, isAuthenticated } = useAuth();

  const [saldo, setSaldo] = useState(0);
  const [saldoServicio, setSaldoServicio] = useState(0);
  const [saldoPaqueteria, setSaldoPaqueteria] = useState(0);
  const [saldoRecarga, setSaldoRecarga] = useState(0);

  const getWalletEvents = useCallback(async (userId) => {
    const wallEv = await firestore
      .collection('walletEvents')
      .where('user_id', '==', userId)
      .orderBy('date', 'desc')
      .limit(2)
      .get()
      .then((query) => {
        const data = [];
        query.forEach((doc) => {
          const obj = { id: doc.id, ...doc.data() };
          data.push(obj);
          //   console.log(doc.id, ' => ', doc.data());
        });
        return data;
      });
    // console.log('los eventooooooooooos', wallEv);
    return wallEv;
  }, []);

  // console.log('wallet', saldo, saldoServicios, saldoPaqueteria, saldoRecarga);
  useEffect(() => {
    async function getSaldo() {
      await firestore
        .collection('wallets')
        .doc(user.id)
        .onSnapshot(async (snapshot) => {
          if (snapshot.exists) {
            setSaldoServicio(snapshot.data().saldoServicio || 0);
            setSaldoPaqueteria(snapshot.data().saldoPaqueteria || 0);
            setSaldoRecarga(snapshot.data().saldoRecarga || 0);

            // console.log(snapshot.data());
          }
          // else if (isAuthenticated && !snapshot.exists) {
          //   const wallEvent = await getWalletEvents(user.id);

          //   if (wallEvent.length) {
          //     const selectedEvent = wallEvent[0];

          //     firestore.collection('wallets').doc(user.id).set({
          //       saldoServicio: selectedEvent.saldoServicio.result,
          //       saldoPaqueteria: selectedEvent.saldoPaqueteria.result,
          //       saldoRecarga: selectedEvent.saldoRecarga.result
          //     });

          //     firestore.collection('walletEvents').add({
          //       date: new Date(),
          //       initWallet: true,
          //       user_id: user.id,
          //       reason: 'INITIALIZATION_BY_REF',
          //       wallEventRefId: selectedEvent.id,
          //       saldoServicio: {
          //         prev: selectedEvent.saldoServicio.result,
          //         result: selectedEvent.saldoServicio.result
          //       },
          //       saldoPaqueteria: {
          //         prev: selectedEvent.saldoPaqueteria.result,
          //         result: selectedEvent.saldoPaqueteria.result
          //       },
          //       saldoRecarga: {
          //         prev: selectedEvent.saldoRecarga.result,
          //         result: selectedEvent.saldoRecarga.result
          //       }
          //     });
          //   } else {
          //     firestore
          //       .collection('wallets')
          //       .doc(user.id)
          //       .set({ saldoServicio: 0, saldoPaqueteria: 0, saldoRecarga: 0 });

          //     firestore.collection('walletEvents').add({
          //       date: new Date(),
          //       initWallet: true,
          //       user_id: user.id,
          //       reason: 'INITIALIZATION',
          //       saldoServicio: {
          //         prev: 0,
          //         result: 0
          //       },
          //       saldoPaqueteria: {
          //         prev: 0,
          //         result: 0
          //       },
          //       saldoRecarga: {
          //         prev: 0,
          //         result: 0
          //       }
          //     });
          //   }

          //   // firestore
          //   //   .collection('walletEvents')
          //   //   .add({ user_id: user.id, wallet_id: user.id, initializationDate: new Date() });
          // }
        });
    }

    if (isAuthenticated) {
      getSaldo();
    }
  }, [user, isAuthenticated, getWalletEvents]);

  const createWallet = (userId) => {
    firestore
      .collection('wallets')
      .doc(userId)
      .get()
      .then((doc) => {
        if (doc.exists) {
          setSaldoServicio(doc.data().saldoServicio);
          setSaldoPaqueteria(doc.data().saldoPaqueteria);
          setSaldoRecarga(doc.data().saldoRecarga);
        } else {
          firestore.collection('wallets').doc(userId).set({ saldoServicio: 0, saldoPaqueteria: 0, saldoRecarga: 0 });

          firestore.collection('walletEvents').add({
            date: new Date(),
            initWallet: true,
            user_id: userId,
            reason: 'INITIALIZATION',
            saldoServicio: {
              prev: 0,
              result: 0
            },
            saldoPaqueteria: {
              prev: 0,
              result: 0
            },
            saldoRecarga: {
              prev: 0,
              result: 0
            }
          });
        }
      });
  };

  const cobrar = useCallback(async (monto, walletId, categoriaId) => {
    const newMonto = Number(monto);
    let categoria;
    if (categoriaId === 'SERVICIO') {
      categoria = 'saldoServicio';
    }
    if (categoriaId === 'PAQUETERIA') {
      categoria = 'saldoPaqueteria';
    }
    if (categoriaId === 'RECARGA') {
      categoria = 'saldoRecarga';
    }

    const userWallet = await (await firestore.collection('wallets').doc(walletId).get()).data();

    const newSaldo = (Number(userWallet[categoria]) || 0) - newMonto;

    if (newSaldo >= 0) {
      await firestore
        .collection('wallets')
        .doc(walletId)
        .update({ [categoria]: newSaldo });
    } else {
      throw new Error('saldo insuficiente');
    }
  }, []);

  // --- funciones para recargar---

  // el walletId tambien es el id del usuario
  // pongo walletid y no user id porque tambien tiene que funcionar cuando otra persona haga la recarga esta wallet

  const recargar = useCallback(async (monto, walletId, categoriaId) => {
    const newMonto = Number(monto);
    let categoria;
    if (categoriaId === 'SERVICIO') {
      categoria = 'saldoServicio';
    }
    if (categoriaId === 'PAQUETERIA') {
      categoria = 'saldoPaqueteria';
    }
    if (categoriaId === 'RECARGA') {
      categoria = 'saldoRecarga';
    }
    const userWallet = await (await firestore.collection('wallets').doc(walletId).get()).data();

    // console.log('wallet usuario', userWallet);
    await firestore
      .collection('wallets')
      .doc(walletId)
      // .update({ saldo: saldo + newMonto });
      .update({ [categoria]: (Number(userWallet[categoria]) || 0) + newMonto });
  }, []);

  const recargarSelf = useCallback(
    async (monto) => {
      await firestore
        .collection('wallets')
        .doc(user.id)
        .update({ saldo: saldo + monto });
    },
    [saldo, user]
  );

  //  -------------------

  const transferir = useCallback(
    async (userid, monto) => {
      const myWallet = await (await firestore.collection('wallets').doc(user.id).get()).data();
      if (myWallet.saldo >= monto) {
        await firestore
          .collection('wallets')
          .doc(userid)
          .get()
          .then((doc) => {
            const { saldo } = doc.data();
            firestore
              .collection('wallets')
              .doc(userid)
              .update({ saldo: saldo + monto });
            cobrar(monto);
          });
      }
    },
    [user, cobrar]
  );

  return (
    <WalletContext.Provider
      value={{ saldo, saldoServicio, saldoPaqueteria, saldoRecarga, recargar, cobrar, transferir, createWallet }}
    >
      {children}
    </WalletContext.Provider>
  );
}
